<template>
  <modal
    title="Lead Status"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div>
        <label class="label">Status:</label>
        <input
          type="text"
          class="input"
          placeholder="Enter"
          v-model="leadStatus"
        />
      </div>

      <div class="actions pt-4 flex justify-between">
        <div class="cursor-pointer" @click="closeModal">
          <p>Cancel</p>
        </div>
        <div>
          <base-button
            text="Save"
            p="py-1 px-6"
            :loading="loading"
            @click="submit"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    leadStatuses: {
      required: true,
    },
    selectedLeadStatusIndex: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      leadStatus: "",
    };
  },
  mounted() {},
  watch: {
    selectedLeadStatusIndex() {
      if (this.selectedLeadStatusIndex != null) {
        this.leadStatus = this.leadStatuses[this.selectedLeadStatusIndex];
      }
    },
  },
  methods: {
    closeModal() {
      this.leadStatus = "";
      this.$emit("close-modal");
    },

    async submit() {
      this.loading = true;
      let payload = {
        // payload: {
        //   setting: ["new", "qualified", "unqualified", "high-prospect"],
        // },
      };
      if (this.selectedLeadStatusIndex == null) {
        payload = {
          payload: {
            setting: [...this.leadStatuses, this.leadStatus],
          },
        };
      } else {
        let updatedLeadStatuses = [...this.leadStatuses];
        updatedLeadStatuses[this.selectedLeadStatusIndex] = this.leadStatus;
        payload = {
          payload: {
            setting: [...updatedLeadStatuses],
          },
        };
      }
      try {
        const response = await this.$_updateLeadStatus(payload);
        this.log(response);
        this.$emit("updated");
        this.generateToast("Success", "success");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
